import TextSlider from './TextSlider';
import DesktopSlider from './DesktopSlider';

export { TextSlider, DesktopSlider };
